import { useQuery } from '@tanstack/react-query';
import { getSessionEpisodes } from '../api/episodes';

/**
 * Poll the Nimbus episodes bound to a session (liveness chips etc.).
 * Owns the cache key + polling cadence so every consumer shares one
 * query; pauses while the tab is hidden.
 */
export const useSessionEpisodes = (sessionId?: string) =>
  useQuery({
    queryKey: ['sessionEpisodes', sessionId],
    queryFn: () => getSessionEpisodes(sessionId as string),
    enabled: !!sessionId,
    refetchInterval: 10_000,
    refetchIntervalInBackground: false,
    staleTime: 5_000,
  });
